import { render, staticRenderFns } from "./RecordRegressData.vue?vue&type=template&id=1ba417ee"
import script from "./RecordRegressData.vue?vue&type=script&lang=js"
export * from "./RecordRegressData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports